import { stageVideoStore } from './store.js';
import { assignVideo } from './ajax.js';
import { triggerStageVideosReload } from './render.js';

/**
 * Handle click events via event delegation
 * @param {Event} e - Click event
 */
export function handleClick(e) {
	const deleteBtn = e.target.closest('.delete-item');
	if (!deleteBtn) return;

	const videoId = deleteBtn.getAttribute('data-video-id');
	if (!videoId) return;

	removeVideo(videoId);
}

/**
 * Remove video by ID
 * @param {string} videoId - Video ID to remove
 */
async function removeVideo(videoId) {
	const stageId = stageVideoStore.getStageId();
	const videoIds = stageVideoStore.getVideoIds();
	const filteredIds = videoIds.filter(id => String(id) !== String(videoId));
	await assignVideo(stageId, filteredIds);
	triggerStageVideosReload();
}
